import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import i18next from 'i18next';
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import translate from 'signin-app/helpers/translate';
import PersonButton from 'signin-app/components/person-button';
import Header from 'signin-app/components/header';
import { staffGroup } from 'signin-app/staff-group/selectors';
import * as PrivateRouteSelectors from 'signin-app/components/private-route/selectors';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { StyledPageContainer } from 'signin-app/components/containers';
import { useElementDimensions, useGetPages } from 'signin-app/group/hooks';
import { SwipeableView } from 'signin-app/group/swipe-view';
import { GroupGrid } from 'signin-app/components/group-grid';
import { Spinner } from '@famly/mf_feedback_spinner';
import { hasSignInRedesign } from 'signin-app/select-children/has-sign-in-redesign';
const StaffCards = React.lazy(() => import('./staff-cards').then(module => ({ default: module.StaffCards })));
export const StaffGroup = (props) => {
    const group = useTypedSelector(state => staffGroup(state, { staffGroupId: props.match.params.staffGroupId }));
    const isFetching = useTypedSelector(PrivateRouteSelectors.isPrefetching);
    const usesNewerScreens = useTypedSelector(hasSignInRedesign);
    const hasStaff = Boolean(group === null || group === void 0 ? void 0 : group.employees.size);
    const items = React.useMemo(() => {
        if (!group) {
            return [];
        }
        return group.employees;
    }, [group]);
    const { dimensions, ref: swipeAreaRef } = useElementDimensions();
    const { pages } = useGetPages({
        items,
        width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
        height: dimensions === null || dimensions === void 0 ? void 0 : dimensions.height,
    });
    if (isFetching) {
        return (_jsx(Stack, { justifyContent: "center", marginY: 6, children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) }));
    }
    return (_jsxs(StyledPageContainer, { "data-e2e-id": "signin-staff-group", children: [_jsx(Header, { centerElement: _jsx(Text, { variant: "h4", color: "n400", textAlign: "center", children: group === null || group === void 0 ? void 0 : group.title }) }), _jsxs(Stack, { flexDirection: "column", gap: 8, mt: 6, flex: 1, children: [!hasStaff ? (_jsx(Box, { textAlign: "center", color: "n400", mt: 8, children: translate('noEmployees') })) : null, hasStaff && usesNewerScreens ? (_jsx(React.Suspense, { fallback: null, children: _jsx(StaffCards, { staff: items }) })) : null, hasStaff && !usesNewerScreens ? (_jsx(Stack, { ref: swipeAreaRef, flex: 1, children: _jsx(SwipeableView, { children: pages.map(({ items, pageId }) => (_jsx(GroupGrid, { children: items.map(employee => {
                                    return (_jsx(PersonButton, { linkTo: employee.checkedIn
                                            ? `/employee/${employee.id}/checkout`
                                            : `/employee/${employee.id}/checkin`, person: employee }, employee.id));
                                }) }, pageId))) }, Date.now()) })) : null] })] }));
};
